// extracted by mini-css-extract-plugin
export default {"header":"index_header__EONCQ","font18":"index_font18__8Y7ay"};